import { useState, useEffect, useCallback } from 'react'
import useAuthenStore from '../../stores/authen/authenStore'
import * as umServiceURL from './umServiceURL'
import useCallApi from '../../utilities/axios'

export type SettingCertificateResponseType = {
    certificateID: number
    description: Translation
    condition: Translation
    logoURL: Translation
    descriptionExempt: Translation
    conditionExempt: Translation
}

export type PutSettingCertificateValueType = {
    certificateID: number
    description: Translation
    condition: Translation
    imgUpload_th: FileType[]
    imgUpload_en: FileType[]
    userID: number
    descriptionExempt: Translation
    conditionExempt: Translation
}

export type PostSettingCertificateValueType = {
    description: Translation
    condition: Translation
    imgUpload_th: FileType[]
    imgUpload_en: FileType[]
}

export type FileType = {
    fileToken: string
    filename: string
    path: string
}

type Translation = {
    th: string
    en: string
}

export type PutSettingCertificateResponseType = {
    message: string
}

export const useSettingCertificate = () => {
    const callApi = useCallApi()

    const getSettingCertificate = async (userID: number) => {
        const { data } = await callApi.axiosGet<SettingCertificateResponseType>({
            url: `${umServiceURL.getSettingCertificate}?userID=${userID}`,
        })
        return data
    }

    const putSettingCertificate = async (value: PutSettingCertificateValueType) => {
        const { data } = await callApi.axiosPut<PutSettingCertificateResponseType>({
            url: `${umServiceURL.putSettingCertificate}/${value.certificateID}`,
            params: { ...value },
        })

        return data
    }

    const postSettingCertificate = async (value: PostSettingCertificateValueType) => {
        const { data } = await callApi.axiosPost<PutSettingCertificateResponseType>({
            url: `${umServiceURL.postSettingCertificate}`,
            params: { ...value },
        })

        return data
    }

    return {
        getSettingCertificate,
        putSettingCertificate,
        postSettingCertificate,
    }
}
